import type { SimilarWorksheetBySchoolTest as SimilarWorksheetBySchoolTestT } from '@/api/worksheet.api'

export class WorksheetBySchoolTest {
  id: number
  sidoName: string
  sigunguName: string | null
  schoolName: string
  year: number
  title: string
  chapter: string
  assignedStudentWorksheetList: _AssignedStudentWorksheet[] = []

  constructor(data: SimilarWorksheetBySchoolTestT) {
    this.id = data.id
    this.sidoName = data.region.sidoName
    this.sigunguName = data.region.sigunguName
    this.schoolName = data.school.name
    this.year = data.year
    this.title = data.title
    this.chapter = data.chapter
    this.assignedStudentWorksheetList = data.assignList
  }
}
